module.exports = __webpack_public_path__ + "img/img1.270eaa91.jpg";